import IRepository from "data/IRepository";
import { injectable } from "inversify";
import AdvanceChangeParamsDTO from "features/requirements/dtos/AdvanceChangeParamsDTO";
import AdvanceCanReduceDTO from "features/requirements/dtos/AdvanceCanReduceDTO";
import IAdvanceFormService from "./IAdvanceFormService";
import { inversifyContainer } from "infrastructure/ioc/ioc.container";
import { IocTypes } from "infrastructure/ioc/ioc.types";
import { getQueryParams } from "features/shared/helpers/queryParams";
import { Requirements_AdvanceChangeCanReduce, Requirements_AdvanceChangeGetParams } from "data/endpoints";
import { ValueActionType } from "features/shared/forms/hooks/useForm";
import { formatPrice } from "features/shared/helpers/Formatters";

@injectable()
export default class AdvanceFormService implements IAdvanceFormService {
  private readonly _paramsRepository: IRepository<AdvanceChangeParamsDTO>;
  private readonly _reduceRepository: IRepository<AdvanceCanReduceDTO>;
    
  constructor() {
    this._paramsRepository = inversifyContainer.get<IRepository<AdvanceChangeParamsDTO>>(IocTypes.Repository);
    this._reduceRepository = inversifyContainer.get<IRepository<AdvanceCanReduceDTO>>(IocTypes.Repository);
  }

  fetchAdvanceParams(contractId: string): Promise<AdvanceChangeParamsDTO> {
    return this._paramsRepository.getOne({
      url: Requirements_AdvanceChangeGetParams,
      params: getQueryParams("ContractId", contractId),
    });
  }

  fetchAdvanceCanReduce(contractId: string): Promise<AdvanceCanReduceDTO> {
    return this._reduceRepository.getOne({
      url: Requirements_AdvanceChangeCanReduce,
      params: getQueryParams("ContractId", contractId),
    });
  }

  setDefaulAdvanceValues(
    advanceParams: AdvanceChangeParamsDTO,
    setFormValue: (key: string, value: any, action: ValueActionType) => void
  ): void {
    // set actual distribution of advances
    setFormValue("DESC_TMzalohyRozlozeni", advanceParams.advanceFrequency, "add");

    if (advanceParams.actualAdvanceSettings) {
      for (const advance of advanceParams.actualAdvanceSettings) {
        let order = advance.orderOfDueDate;
        let amount = advance.amount ?? 0;
        let maturity = advance.month ? `${advance.day}.${advance.month}.` : `${advance.day}. den v měsíci`;

        setFormValue(`DESC_TMzalohyAktVyse${order}`, formatPrice(amount, advance.currency!, 2), "add");
        setFormValue(`DESC_TMzalohySplatnost${order}`, maturity, "add");
      }   
    }
  }

  clearPreviousAdvanceValues(setFormValue: (key: string, value: any, action: ValueActionType) => void): void {
    let countOfDueDates = 5;

    for (let i = 1; i <= countOfDueDates; i++) {
      setFormValue(`DESC_TMzalohyNovaVyse${i}`, null, "remove");
      setFormValue(`DESC_TMzalohyAktVyse${i}`, null, "remove");
      setFormValue(`DESC_TMzalohySplatnost${i}`, null, "remove");
    }
  }

  prepareValuesToSend(values: Record<string, any>): Record<string, string> {
    let result: Record<string, string> = {};
    for (const [key, value] of Object.entries(values)) {
      // in numbers replace comma to dot
      if (key.startsWith("DESC_TMzalohyNovaVyse")) {
        result[key] = String(value).replace(",", ".");
      } else {
        result[key] = value;
      }
    }

    return result;
  }
}